import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import HomePage from "./Pages/Home";
import ListingPage from "./Pages/ListingPage";
import Pricing from "./Pages/pricingPage";
import AdsOnPage from "./Pages/adsOn";
import ProfilePage from "./Pages/Profile";
import BookingPage from "./Pages/BookingPage";
import NoBookingPage from "./Pages/NoBookingPage";
import LoginPage from "./Pages/Login";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>

          <Route path="/home" element={<HomePage />} />

          <Route path="/listing-page" element={<ListingPage />} />

          <Route path="/pricing" element={<Pricing />} />

          <Route path="/ads-on" element={<AdsOnPage />} />

          <Route path="/profile" element={<ProfilePage />} />

          <Route path="/bookings" element={<BookingPage />} />

          <Route path="/no-bookings" element={<NoBookingPage />} />

        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter; 